import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, map, tap } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { BookingDetailMapper } from "@app/core/booking/data/network/booking-detail.mapper";
import { BookingDetail } from "@app/core/booking/domain/model/booking-detail";
import { MatchSearchCriteria } from "@app/core/match/domain/match-search-criteria";
import { MatchSearchCriteriaMapper } from "@app/core/match/data/network/match-search-criteria.mapper";

@Injectable({
  providedIn: "root",
})
export class GetBookingsWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(matchCriteria:MatchSearchCriteria, token: string): Observable<BookingDetail[]> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.GET_BOOKINGS_ENDPOINT())
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .setUrlParams(
        // It is necessary to serialize to put the parameters in such a way that the API accepts them
        MatchSearchCriteriaMapper.serialize(matchCriteria)
      )
      .build();
    return this.baseHandler.execute(parameters).pipe(
      map((response) =>
        response.matches_request_list.map(BookingDetailMapper.deserialize)
      ),
    );
  }
}
